import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import {
  ErrorHandler,
  Inject,
  Injectable,
  Optional,
  PLATFORM_ID,
} from '@angular/core';
import { RESPONSE } from '@nguniversal/express-engine/tokens';
import { Response } from 'express';
import { ErrorTracking } from './error-tracking.service';

@Injectable()
export class CustomErrorHandler extends ErrorHandler {
  isBrowser: boolean;

  constructor(
    private errorTracking: ErrorTracking,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Optional() @Inject(RESPONSE) private response: Response,
  ) {
    super();
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  handleError(error: any): void {
    // When on the server, abort & return a 500
    if (isPlatformServer(this.platformId)) {
      // The Angular Router currently throws on URLs with scripts tags or
      // invalid characters
      // See https://github.com/angular/angular/issues/21032
      if (
        error.message.includes('Error: Cannot match any routes. URL Segment: ')
      ) {
        this.response.status(400);
        this.response.locals.error = error.rejection ? error.rejection : error;
        return;
      }
      this.response.status(500);
      this.response.locals.error = error.rejection ? error.rejection : error;
      return;
    }
    // When on the browser, report to Sentry
    const err = error.originalError || error;
    if (!err.isBackendError) {
      // We don't log backend errors in Sentry as there are already logged in
      // Kibana
      this.errorTracking.captureException(error.originalError || error);
    }
    // Angular's native error handler breaks WebDriverJS console read API.
    // FIXME: detect Protractor env better
    if (
      isPlatformBrowser(this.platformId) &&
      window.location.host === 'localhost:5000'
    ) {
      console.error(error);
    } else {
      super.handleError(error);
    }
  }
}
